import { render } from "./HorseEditLaboratoryView.vue?vue&type=template&id=a1a0b2ae&scoped=true"
import script from "./HorseEditLaboratoryView.vue?vue&type=script&lang=js"
export * from "./HorseEditLaboratoryView.vue?vue&type=script&lang=js"

import "./HorseEditLaboratoryView.vue?vue&type=style&index=0&id=a1a0b2ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a0b2ae"]])

export default __exports__